export default __webpack_public_path__ + "static/media/CY.6bec049b.svg";